import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import RoomItemForm from '../../components/MangeHKT/RoomItemForm'
import TaskForm from '../../components/MangeHKT/TaskForm'

function EditTask() {
    const navigate = useNavigate()
    const { id } = useParams()
    const selectedProperty = JSON.parse(localStorage.getItem('selectedProperty')) || {}
    const roomItemData = JSON.parse(localStorage.getItem('room-tem-data')) || {}
    const manage_hkt_data = JSON.parse(localStorage.getItem('edit-manage-hkt')) || {}
    const [selectedData, setSelectedData] = useState()
    // handleGoBack
    const handleGoBack = () => {
        navigate(-1)
    }

    // create action
    const handleForm = async (propsData) => {
        console.log(propsData)
        const { property, taskDescription, taskName, taskSubType, status } = propsData
        if (propsData) {
            const data = {
                rit_id: Number(id),
                tasktypes_id: Number(taskSubType),
                properties_id: Number(property),
                item_task_name: taskName,
                item_task_description: taskDescription,
                status: "active",
            };
            try {
                const response = await nbrApi.post('/updateroomitemtask', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Room Task Updated Successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Room Task Update failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Room Task Updated Failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    useEffect(() => {
        if (id) {
            const getData = async () => {
                try {
                    const response = await nbrApi.get(`/gettasksbypbytt?properties_id=${selectedProperty.value}&tt_id=${roomItemData?.taskType}`);

                    const data = response.data;
                    let modified_data = data?.find(e => e?.rit_id === parseInt(id))
                    setSelectedData(modified_data);

                } catch (error) {
                    console.error('Error fetching data:', error.message);
                }
            }

            getData()
        }
    }, [id])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Edit Room Task</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'><i className='fa fa-undo' /> Go Back</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <TaskForm handleAction={handleForm} selectedData={selectedData} taskType={roomItemData?.taskType} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditTask